<template>
  <b-row>
    <!-- Modal Filter -->
    <FilterJobLibraries
      :showModalFilter="showModalFilter"
      :filters="jobLibraries.params"
      @close="showModalFilter = false"
      @apply-filter="fetchData"
      tab="all"
    />

    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExport"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <!-- Modal Engine List -->
    <b-modal
      hide-footer
      title="Engine List"
      size="lg"
      v-model="modalEngine.show"
    >
      <table class="table table-striped" v-if="modalEngine.data">
        <thead class="thead-light">
          <th>Engine Name</th>
          <th>Engine Type</th>
          <th>Interval</th>
        </thead>
        <tbody>
          <tr v-for="engine in modalEngine.data" :key="engine.id">
            <td>
              {{ engine?.power_series?.name }}
              <br />
              <small>{{ engine?.power_series?.model }}</small>
            </td>
            <td>{{ engine?.power_type?.name || '-' }}</td>
            <td>{{ formatNumber(engine?.interval_hour) }} Hours</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <!-- End Modal Engine List -->

    <!-- Modal Fleet / Assign Fleet -->
    <template v-if="modalFleet.show">
      <SelectFleetJobLibrary
        :isOpen="modalFleet.show"
        :jobLibraryIds="selectedJobIds"
        @close="handleCloseModalFleet"
        :isPreview="modalFleet.isPreview"
        @next="onSelectedFleets"
        :fleetsSelected="modalFleet.fleetSelecteds"
        :title="modalFleet.isPreview ? 'Fleets Assigned' : 'Select Fleets'"
      />
    </template>

    <!-- Form Job Library -->
    <custom-sidebar v-model="sidebar.show" size="50%" :title="sidebar.title">
      <template v-if="sidebar.show">
        <template v-if="sidebar.title == 'New Job Library'">
          <FormJobLibraries
            @close="closeSidebar"
            @refetch="fetchData()"
            :selectedData="jobLibraries.detailData"
          />
        </template>
        <template v-else-if="sidebar.title == 'Edit Job Library'">
          <FormJobLibraries
            @close="closeSidebar"
            @refetch="fetchData()"
            :selectedData="jobLibraries.detailData"
          />
        </template>
        <template v-else>
          <DetailJobLibraries :selectedData="jobLibraries.detailData" />
        </template>
      </template>
    </custom-sidebar>

    <!-- Form Assign Fleets -->
    <CustomSidebar
      v-model="sidebarAssign"
      size="100%"
      title="Assign Job Library To Fleet"
    >
      <template v-if="sidebarAssign">
        <FormAssignFleets
          :selectedFleets="selectedFleets"
          @close="sidebarAssign = false"
          @refetch="fetchData"
        />
      </template>
    </CustomSidebar>

    <b-col sm="12">
      <template>
        <div class="d-flex justify-content-between">
          <div class="d-flex mb-3">
            <div class="mr-2">
              <b-form-input
                v-model="jobLibraries.params.search"
                style="width: 240px"
                type="text"
                class="mr-2"
                placeholder="Search..."
              ></b-form-input>
            </div>
            <b-button
              type="button"
              variant="outline-primary"
              @click="showModalFilter = true"
            >
              <i class="fa fa-sliders"></i>
              Filter Data
            </b-button>
          </div>
          <div class="d-flex">
            <!-- <b-button
                variant="outline-primary"
                style="height: max-content"
                class="mr-2 d-flex align-items-center"
                @click="handleExport"
              >
                <i class="ri-download-2-line pl-1"></i>Export
              </b-button> -->
            <b-button
              variant="outline-primary"
              class="d-flex align-items-center mr-2"
              style="height: max-content"
              @click="showModalImport = true"
            >
              <i class="ri-upload-2-line pl-1"></i>
              Import
            </b-button>
            <b-button
              variant="primary"
              @click="openSidebar()"
              style="height: max-content"
            >
              <i class="fa fa-plus mr-2"></i>
              New Data
            </b-button>
            <b-button
              :disabled="selectedJobIds.length === 0"
              variant="primary"
              @click="openModalAssign()"
              style="height: max-content"
              class="ml-2"
            >
              Assign to Fleets
            </b-button>
          </div>
        </div>

        <!-- List -->
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="thead-light">
              <tr>
                <th>
                  <b-form-checkbox
                    class="d-flex justify-content-center"
                    :checked="isCheckedAll"
                    @change="toggleSelectAll"
                  ></b-form-checkbox>
                </th>
                <th>Job Name</th>
                <th>Equipment / Category</th>
                <th>Assigned</th>
                <th>Job Type / Class</th>
                <th class="text-center">Interval</th>
                <th>Engine Name</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in jobLibraries.data" :key="index">
                <td>
                  <b-form-checkbox
                    type="checkbox"
                    :value="item.id"
                    v-model="selectedJobIds"
                    class="d-flex justify-content-center"
                  ></b-form-checkbox>
                </td>
                <td>{{ item.name }}</td>
                <td>
                  <strong class="text-primary">
                    {{ item.maintenance_master.equipment_name }}
                  </strong>
                  <br />
                  <small>{{ item.maintenance_component.component_name }}</small>
                </td>
                <td>
                  <span
                    @click="handleClickPreviewFleet(item)"
                    class="cursor-pointer text-primary fw-bold"
                  >
                    {{ item.assigned }} Fleet
                  </span>
                </td>
                <td>
                  <strong class="text-black">
                    {{ item.maintenance_job_type?.description ?? '-' }}
                  </strong>
                  <br />
                  <small>
                    {{ item.maintenance_job_class?.job_class ?? '-' }}
                  </small>
                </td>

                <td align="center" class="text-nowrap">
                  <span v-if="item.method == 'CALENDAR'">
                    {{ item.calendar_interval ?? '-' }}
                    {{ item.calendar_type ?? '' }}
                  </span>
                  <span v-if="item.job_library_counters?.length">
                    {{ formatNumber(item.job_library_counters[0].interval_hour) }}
                    Hours
                  </span>
                  <br />
                  <small>{{ item?.method }}</small>
                </td>
                <td class="text-center">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    v-if="item.job_library_counters?.length"
                    @click="
                      modalEngine.show = true
                      modalEngine.data = item.job_library_counters
                    "
                  >
                    Engine List
                  </b-button>
                  <template v-else>-</template>
                </td>
                <td align="center">
                  <b-dropdown
                    size="sm"
                    variant="outline-primary"
                    text="Action"
                    right
                  >
                    <b-dropdown-item @click.prevent="openSidebar(item)">
                      Edit
                    </b-dropdown-item>
                    <b-dropdown-item @click.prevent="openSidebar(item, true)">
                      Detail
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click.prevent="deleteItem(item)"
                      class="text-danger"
                    >
                      Delete
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
            <b-pagination
              class="mb-0 mr-3"
              @input="fetchData"
              v-model="jobLibraries.params.page"
              :total-rows="jobLibraries.params.total"
              :per-page="jobLibraries.params.limit"
              first-number
              align="center"
            ></b-pagination>
            <b-form-select
              plain
              v-model="jobLibraries.params.limit"
              :options="limitOptions"
              style="width: 140px"
              @input="() => fetchData()"
            ></b-form-select>
          </div>
        </div>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import FormJobLibraries from './Components/FormJobLibraries.vue'
import SelectFleetJobLibrary from './Components/SelectFleetJobLibrary.vue'
import FormAssignFleets from './FormAssignFleets.vue'
import DetailJobLibraries from './Components/DetailJobLibraries.vue'
import FilterJobLibraries from './Components/FilterJobLibraries.vue'
import { debounce } from 'lodash'

export default {
  name: 'jobLibraries',
  components: {
    CustomSidebar,
    FormJobLibraries,
    SelectFleetJobLibrary,
    CustomSidebar,
    FormJobLibraries,
    FormAssignFleets,
    DetailJobLibraries,
    FilterJobLibraries,
  },
  data() {
    return {
      modalFleet: {
        show: false,
        isPreview: false,
        jobIds: [],
        fleetSelecteds: [],
      },
      modalEngine: {
        show: false,
        data: null,
      },
      selectedFleets: [],
      selectedJobIds: [],
      jobClassOptions: [],
      jobTypeOptions: [],
      sidebarAssign: false,
      showModalImport: false,
      importFile: null,
      showModalFilter: false,
      limitOptions,
      categoryOptions: [],
      typeFleet: [],
      sidebar: {
        show: false,
        title: '',
        size: '50%',
      },
      jobLibraries: {
        editMode: false,
        params: {
          search: '',
          vehicleTypeIds: [],
          jobClassIds: [],
          jobTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
          maintenance_component_id: null,
        },
        data: [],
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...pmsActions,
    formatNumber(number) {
      if (!number && number !== 0) return '0'
      return Number(number).toLocaleString('id-ID')
    },
    debouncedSearch: debounce(function () {
      this.jobLibraries.params.page = 1
      this.fetchData()
    }, 500),
    onSelectedFleets(fleets) {
      this.selectedFleets = fleets
      this.sidebarAssign = true
    },
    handleCloseModalFleet() {
      this.modalFleet.show = false
      this.modalFleet.isPreview = false
      this.modalFleet.fleetSelecteds = []
      this.modalFleet.jobIds = []
    },
    handleClickPreviewFleet(item) {
      this.modalFleet.fleetSelecteds = item?.assigned_vehicles
      this.modalFleet.isPreview = true
      this.modalFleet.show = true
      this.modalFleet.jobIds = [item.id]
    },
    toggleSelectAll(checked) {
      const currentPageIds = this.jobLibraries.data.map((job) => job.id)
      if (checked) {
        const unique = new Set([...this.selectedJobIds, ...currentPageIds])
        this.selectedJobIds = Array.from(unique)
      } else {
        this.selectedJobIds = this.selectedJobIds.filter(
          (id) => !currentPageIds.includes(id)
        )
      }
    },
    async handleImport() {
      try {
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importEquipment(formData)
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
        })
      } finally {
        this.fetchData()
      }
    },
    async handleExport() {
      try {
        const res = await this.exportTemplateEquipment()
        saveAs(res.data, 'template_job_libraries.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      }
    },
    openSidebar(data, isDetail = false) {
      this.sidebar.show = true
      if (data) {
        this.jobLibraries.detailData = data
        if (isDetail) {
          this.sidebar.title = 'Detail Job Library'
        } else {
          this.sidebar.title = 'Edit Job Library'
        }
      } else {
        this.sidebar.title = 'New Job Library'
        this.jobLibraries.detailData = null
      }
    },
    openModalAssign() {
      this.modalFleet.jobIds = this.jobLibraries.data.map((item) => item.id)
      this.modalFleet.isPreview = false
      this.modalFleet.show = true
    },

    openModalAssignSingle(job) {
      this.modalFleet.jobIds = [job.id]
      this.modalFleet.isPreview = false
      this.modalFleet.show = true
    },

    closeSidebar() {
      this.sidebar.show = false
    },

    async fetchData(page = 1) {
      const res = await this.getJobLibraries({
        page: this.jobLibraries.params.page || page,
        limit: this.jobLibraries.params.limit,
        search: this.jobLibraries.params.search,
        vehicleTypeId: this.jobLibraries.params.vehicleTypeIds?.toString(),
        maintenance_component_id:
          this.jobLibraries.params.maintenance_component_id ||
          this.$route.query?.maintenance_component_id,
        job_class_id: `${this.jobLibraries.params.jobClassIds}`,
        job_type_id: `${this.jobLibraries.params.jobTypeIds}`,
        sort: 'ASC',
      })

      if (res.status === 'success') {
        this.jobLibraries.data = res.data.data
        this.jobLibraries.params = {
          ...this.jobLibraries.params,
          ...res.data.pagination,
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchCategory() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipmentCategory(params)
      if (res.status === 'success') {
        const filteredData = res.data.data
        this.categoryOptions = filteredData
        console.log(res.data)
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async getJobClassList() {
      const params = {
        page: 1,
        perPage: 1000,
      }

      try {
        this.jobClassOptions = []
        const res = await this.getJobClass(params)
        res.data.data.forEach((el) => {
          this.jobClassOptions.push({
            name: `${el.jobClassCode} - ${el.jobClass}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getJobTypeList() {
      try {
        const params = {
          page: 1,
          perPage: 1000,
        }
        this.jobTypeOptions = []
        const res = await this.getJobType(params)
        res.data.data.forEach((el) => {
          this.jobTypeOptions.push({
            name: `${el.jobTypeCode} - ${el.jobTypeIndex}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    async handleSubmit() {
      if (this.jobLibraries.form.maintenance_component_id) {
        this.jobLibraries.form.maintenance_component_id = Number(
          this.jobLibraries.form.maintenance_component_id
        )
      }

      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        },
      })

      if (this.jobLibraries.editMode) {
        const res = await this.updateEquipment({
          id: this.jobLibraries.detailData.id,
          data: this.jobLibraries.form,
        })
        if (res.status === 'success') {
          this.$swal('Update Success!', res.data.message, 'success')
          this.fetchData()
          this.sidebar.show = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const body = {
          ...this.jobLibraries.form,
          alias: this.jobLibraries.form.equipment_name
            .toLowerCase()
            .replace(' ', '_'),
        }
        const res = await this.createEquipment(body)
        if (res.status === 'success') {
          this.$swal('Add Success!', res.data.message, 'success')
          this.fetchData()
          this.sidebar.show = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    deleteItem(dataVal) {
      this.$swal({
        title: 'Delete Equipment Category?',
        text: `${dataVal.text} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteJobLibraries(dataVal.id)
          if (res.status === 'success') {
            this.fetchData()
            this.$swal(
              `Deleted!`,
              `Equipment Category ${dataVal.equipment_name} successfully deleted`,
              'success'
            )
          } else {
            this.$swal('Error', res.data.message || 'Server error', 'error')
          }
        }
      })
    },
  },
  computed: {
    isCheckedAll() {
      return this.jobLibraries.data.every((el) =>
        this.selectedJobIds.some((job) => job == el.id)
      )
    },
  },
  watch: {
    'jobLibraries.params.search'() {
      this.debouncedSearch()
    },
    'jobLibraries.data'(newVal) {
      if (this.$route.query?.maintenance_component_id) {
        this.selectedJobIds = newVal.map((item) => item.id)
      }
    },
  },
  mounted() {
    this.getVehicleTypeData()
    this.fetchData()
    this.getJobClassList()
    this.getJobTypeList()
    if (!this.$route.query?.maintenance_component_id) {
      this.fetchCategory()
    }
  },
}
</script>
<style scoped>
tbody tr td {
  line-height: 1.2;
}
</style>
